import { getStorage } from "../helpers/storage";
import {faker}  from "@faker-js/faker";
import { getAccounts } from "../helpers/get-accounts";
import {
  TERRAFORM_APPLY,
  TERRAFORM_DESTROY,
} from "../../utils/app-constants.json";
import {
  TERRAFORM_TASK_INPUT_PARAMETERS,
  TERRAFORM_TASK_OUTPUT_PARAMETERS,
} from "../mockData/tasks";

var regionCodes = [
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2",
  "ap-south-1",
];

const TERRAFORM_TASK_ID = "1b8542f0-e932-41ca-9e1d-194fbce7264a";
const TASK_ID = "9aab56a1-f5e8-4320-8ab3-03cec6a2ad3a";

export const getScanJobs = async (scanId) => {
  const allSchedules = await getStorage("SCHEDULES");
  let schedule = allSchedules.find((item) => item.ScheduleId === scanId);
  let scanDetails = {
    Category: schedule.Category,
    ScheduleId: schedule.ScheduleId,
    ActionData: {
      Action: "createBackup",
      Accounts: [
        {
          Regions: [
            {
              Action: "createSnapshot",
              RegionCode: "us-east-2",
              Description: "a bit a later",
              VolumeIds: ["vol-0ad8129f1629a63d6"],
              Tags: [{ Key: "purpose", Value: "abitLater" }],
            },
            {
              Action: "createSnapshot",
              RegionCode: "us-east-1",
              Description: "a bit a later",
              VolumeIds: ["vol-0df766338a1c52b28"],
              Tags: [{ Key: "purpose", Value: "abitLater" }],
            },
          ],
          AccountNumber: "964124927860",
        },
      ],
      Schedule: {
        Category: "Storage",
        Description: false,
        IsDisabled: false,
        ResourcePath: "/storage/snapshot",
        ExecuteAt: "2019-08-01 10:45:30",
        Name: "create-snapshot_2019-08-01_16:11:50",
      },
    },

    Description: schedule.Description,
    Title: schedule.Name,
    StatusUpdatedOn: schedule.LastUpdatedAt,
    JobId: schedule.JobId,
    Offset: schedule.Offset,
    CreatedBy: schedule.CreatedBy,
    ExecutionStatus: schedule.LastExecutionStatus,
    Action: schedule.Payload.Action,
    CreatedAt: schedule.CreatedAt,
  };

  return scanDetails;
};

export const getAllJobTasks = (data, isTask) => {
  let accounts = getAccounts();
  let Targets = data.ActionData.Accounts[0].Regions[0].InstanceId;
  let allTasks = [];
  const isTerraform = [TERRAFORM_APPLY, TERRAFORM_DESTROY].includes(
    data.Category
  );
  for (let i = 0; i < Targets.length; i++) {
    let task = {
      ExecutionStatus: data.ExecutionStatus,
      Offset: "1564656376.0004462",
      ActionData: data.ActionData,
      TaskId: isTerraform ? TERRAFORM_TASK_ID : TASK_ID,
      StatusUpdatedOn: data.StatusUpdatedOn,
      ActionCategory: data.Category,
      AccountNumber: faker.helpers.arrayElement(accounts),
      JobId: data.JobId,
      RegionCode: faker.helpers.arrayElement(regionCodes),
      Action: data.ActionData.Action,
      CreatedBy: 1,
      Title: data.Title,
      CreatedAt: data.CreatedAt,
      Targets: [Targets[i]],
      payload: { ActionMapper: { Type: data.Category } },
    };

    if (isTask) {
      let extraProps = {};

      if (isTerraform) {
        extraProps = {
          InputParameters: TERRAFORM_TASK_INPUT_PARAMETERS,
          Type: data.Category,
        };
      }
      Object.assign(
        task,
        {
          AccountNumber: "855075416228",
          Action: "enableSecurityHub",
          ActionData: {
            Accounts: [
              {
                AccountNumber: "855075416228",
                Regions: [
                  {
                    BotConfigurationId: "e6842cca-11f2-4ae3-a53d-eda97cce8620",
                    RegionCode: "us-east-1",
                  },
                ],
              },
            ],
          },
          OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
          OriginCategory: "GENERAL",
          OriginData: {
            ApplicationId: null,
            ApplicationName: null,
            OriginTitle: null,
          },
          OriginSource: "ON-DEMAND",
          OriginSubCategory: "GENERAL",
          RegionCode: "us-east-1",
          Status: "SUCCESS",
        },
        extraProps
      );
    }

    allTasks.push(task);
  }

  return allTasks;
};

export const getTaskOutputLogs = (taskId) => {
  let data = {
    CreatedAt: "1687190927.0409296",
    CreatedBy: "fce23375-fdd4-5b30-8e57-a401e5265ba1",
    Logs: {
      Logs: {
        init: `[0m[1mInitializing the backend...[0m

          [0m[1mInitializing provider plugins...[0m
          - Finding hashicorp/aws versions matching "4.67.0"...
          - Installing hashicorp/aws v4.67.0...
          - Installed hashicorp/aws v4.67.0 (signed by HashiCorp)
          
          Terraform has created a lock file [1m.terraform.lock.hcl[0m to record the provider
          selections it made above. Include this file in your version control repository
          so that Terraform can guarantee to make the same selections by default when
          you run "terraform init" in the future.[0m
          
          [0m[1m[32mTerraform has been successfully initialized![0m[32m[0m
          [0m[32m
          You may now begin working with Terraform. Try running "terraform plan" to see
          any changes that are required for your infrastructure. All Terraform commands
          should now work.
          
          If you ever set or change modules or backend configuration for Terraform,
          rerun this command to reinitialize your working directory. If you forget, other
          commands will detect it and remind you to do so if necessary.[0m
          `,
        validate: `[32m[1mSuccess![0m The configuration is valid.
          [0m`,
        plan: `[0m[1mdata.aws_ami.ami_id: Reading...[0m[0m
          [0m[1mdata.aws_ami.ami_id: Read complete after 2s [id=ami-0f5bca4d7b49c9f49][0m
          
          Terraform used the selected providers to generate the following execution
          plan. Resource actions are indicated with the following symbols:
            [32m+[0m create[0m
          
          Terraform will perform the following actions:
          
          [1m  # aws_db_instance.ProteinResearch_mysql_db[0m will be created
          [0m  [32m+[0m[0m resource "aws_db_instance" "ProteinResearch_mysql_db" {
                [32m+[0m[0m address                               = (known after apply)
                [32m+[0m[0m allocated_storage                     = 20
                [32m+[0m[0m apply_immediately                     = false
                [32m+[0m[0m arn                                   = (known after apply)
                [32m+[0m[0m auto_minor_version_upgrade            = true
                [32m+[0m[0m availability_zone                     = (known after apply)
                [32m+[0m[0m backup_retention_period               = (known after apply)
                [32m+[0m[0m backup_window                         = (known after apply)
                [32m+[0m[0m ca_cert_identifier                    = (known after apply)
                [32m+[0m[0m character_set_name                    = (known after apply)
                [32m+[0m[0m copy_tags_to_snapshot                 = false
                [32m+[0m[0m db_name                               = "ProteinResearch-Enricher-DB"
                [32m+[0m[0m db_subnet_group_name                  = (known after apply)
                [32m+[0m[0m delete_automated_backups              = true
                [32m+[0m[0m endpoint                              = (known after apply)
                [32m+[0m[0m engine                                = "mysql"
                [32m+[0m[0m engine_version                        = "5.7"
                [32m+[0m[0m engine_version_actual                 = (known after apply)
                [32m+[0m[0m hosted_zone_id                        = (known after apply)
                [32m+[0m[0m id                                    = (known after apply)
                [32m+[0m[0m identifier                            = (known after apply)
                [32m+[0m[0m identifier_prefix                     = (known after apply)
                [32m+[0m[0m instance_class                        = "db.t2.micro"
                [32m+[0m[0m iops                                  = (known after apply)
                [32m+[0m[0m kms_key_id                            = (known after apply)
                [32m+[0m[0m latest_restorable_time                = (known after apply)
                [32m+[0m[0m license_model                         = (known after apply)
                [32m+[0m[0m listener_endpoint                     = (known after apply)
                [32m+[0m[0m maintenance_window                    = (known after apply)
                [32m+[0m[0m master_user_secret                    = (known after apply)
                [32m+[0m[0m master_user_secret_kms_key_id         = (known after apply)
                [32m+[0m[0m monitoring_interval                   = 0
                [32m+[0m[0m monitoring_role_arn                   = (known after apply)
                [32m+[0m[0m multi_az                              = (known after apply)
                [32m+[0m[0m name                                  = (known after apply)
                [32m+[0m[0m nchar_character_set_name              = (known after apply)
                [32m+[0m[0m network_type                          = (known after apply)
                [32m+[0m[0m option_group_name                     = (known after apply)
                [32m+[0m[0m parameter_group_name                  = "default.mysql5.7"
                [32m+[0m[0m password                              = (sensitive value)
                [32m+[0m[0m performance_insights_enabled          = false
                [32m+[0m[0m performance_insights_kms_key_id       = (known after apply)
                [32m+[0m[0m performance_insights_retention_period = (known after apply)
                [32m+[0m[0m port                                  = (known after apply)
                [32m+[0m[0m publicly_accessible                   = false
                [32m+[0m[0m replica_mode                          = (known after apply)
                [32m+[0m[0m replicas                              = (known after apply)
                [32m+[0m[0m resource_id                           = (known after apply)
                [32m+[0m[0m skip_final_snapshot                   = true
                [32m+[0m[0m snapshot_identifier                   = (known after apply)
                [32m+[0m[0m status                                = (known after apply)
                [32m+[0m[0m storage_throughput                    = (known after apply)
                [32m+[0m[0m storage_type                          = (known after apply)
                [32m+[0m[0m tags_all                              = {
                    [32m+[0m[0m "Environment" = "PRD"
                    [32m+[0m[0m "Service"     = "Protein Research"
                  }
                [32m+[0m[0m timezone                              = (known after apply)
                [32m+[0m[0m username                              = "masteradmin"
                [32m+[0m[0m vpc_security_group_ids                = (known after apply)
              }
          
          [1m  # aws_elasticsearch_domain.ElasticSearch_Domain[0m will be created
          [0m  [32m+[0m[0m resource "aws_elasticsearch_domain" "ElasticSearch_Domain" {
                [32m+[0m[0m access_policies       = jsonencode(
                      {
                        [32m+[0m[0m Statement = [
                            [32m+[0m[0m {
                                [32m+[0m[0m Action    = "es:ESHttpPut"
                                [32m+[0m[0m Effect    = "Allow"
                                [32m+[0m[0m Principal = "*"
                                [32m+[0m[0m Resource  = "*"
                              },
                          ]
                        [32m+[0m[0m Version   = "2012-10-17"
                      }
                  )
                [32m+[0m[0m advanced_options      = (known after apply)
                [32m+[0m[0m arn                   = (known after apply)
                [32m+[0m[0m domain_id             = (known after apply)
                [32m+[0m[0m domain_name           = "els-proteinresearch-domain"
                [32m+[0m[0m elasticsearch_version = "7.1"
                [32m+[0m[0m endpoint              = (known after apply)
                [32m+[0m[0m id                    = (known after apply)
                [32m+[0m[0m kibana_endpoint       = (known after apply)
                [32m+[0m[0m tags_all              = {
                    [32m+[0m[0m "Environment" = "PRD"
                    [32m+[0m[0m "Service"     = "Protein Research"
                  }
          
                [32m+[0m[0m cluster_config {
                    [32m+[0m[0m dedicated_master_enabled = false
                    [32m+[0m[0m instance_count           = 1
                    [32m+[0m[0m instance_type            = "t2.small.elasticsearch"
                  }
          
                [32m+[0m[0m ebs_options {
                    [32m+[0m[0m ebs_enabled = true
                    [32m+[0m[0m iops        = (known after apply)
                    [32m+[0m[0m throughput  = (known after apply)
                    [32m+[0m[0m volume_size = 20
                    [32m+[0m[0m volume_type = (known after apply)
                  }
          
                [32m+[0m[0m snapshot_options {
                    [32m+[0m[0m automated_snapshot_start_hour = 23
                  }
              }
          
          [1m  # aws_iam_instance_profile.ElasticSearch_Instance_Profile[0m will be created
          [0m  [32m+[0m[0m resource "aws_iam_instance_profile" "ElasticSearch_Instance_Profile" {
                [32m+[0m[0m arn         = (known after apply)
                [32m+[0m[0m create_date = (known after apply)
                [32m+[0m[0m id          = (known after apply)
                [32m+[0m[0m name        = "ELS-ProteinResearch-Instance-Profile"
                [32m+[0m[0m name_prefix = (known after apply)
                [32m+[0m[0m path        = "/"
                [32m+[0m[0m role        = "ElS-ProteinResearch-IAM-Role"
                [32m+[0m[0m tags_all    = {
                    [32m+[0m[0m "Environment" = "PRD"
                    [32m+[0m[0m "Service"     = "Protein Research"
                  }
                [32m+[0m[0m unique_id   = (known after apply)
              }
          
          [1m  # aws_iam_role.ElasticSearch_IAM_Role[0m will be created
          [0m  [32m+[0m[0m resource "aws_iam_role" "ElasticSearch_IAM_Role" {
                [32m+[0m[0m arn                   = (known after apply)
                [32m+[0m[0m assume_role_policy    = jsonencode(
                      {
                        [32m+[0m[0m Statement = [
                            [32m+[0m[0m {
                                [32m+[0m[0m Action    = "sts:AssumeRole"
                                [32m+[0m[0m Effect    = "Allow"
                                [32m+[0m[0m Principal = {
                                    [32m+[0m[0m Service = "ec2.amazonaws.com"
                                  }
                              },
                          ]
                        [32m+[0m[0m Version   = "2012-10-17"
                      }
                  )
                [32m+[0m[0m create_date           = (known after apply)
                [32m+[0m[0m force_detach_policies = false
                [32m+[0m[0m id                    = (known after apply)
                [32m+[0m[0m managed_policy_arns   = (known after apply)
                [32m+[0m[0m max_session_duration  = 3600
                [32m+[0m[0m name                  = "ElS-ProteinResearch-IAM-Role"
                [32m+[0m[0m name_prefix           = (known after apply)
                [32m+[0m[0m path                  = "/"
                [32m+[0m[0m role_last_used        = (known after apply)
                [32m+[0m[0m tags_all              = {
                    [32m+[0m[0m "Environment" = "PRD"
                    [32m+[0m[0m "Service"     = "Protein Research"
                  }
                [32m+[0m[0m unique_id             = (known after apply)
              }
          
          [1m  # aws_iam_role.lambda_execution_role[0m will be created
          [0m  [32m+[0m[0m resource "aws_iam_role" "lambda_execution_role" {
                [32m+[0m[0m arn                   = (known after apply)
                [32m+[0m[0m assume_role_policy    = jsonencode(
                      {
                        [32m+[0m[0m Statement = [
                            [32m+[0m[0m {
                                [32m+[0m[0m Action    = "sts:AssumeRole"
                                [32m+[0m[0m Effect    = "Allow"
                                [32m+[0m[0m Principal = {
                                    [32m+[0m[0m Service = "lambda.amazonaws.com"
                                  }
                              },
                          ]
                        [32m+[0m[0m Version   = "2012-10-17"
                      }
                  )
                [32m+[0m[0m create_date           = (known after apply)
                [32m+[0m[0m force_detach_policies = false
                [32m+[0m[0m id                    = (known after apply)
                [32m+[0m[0m managed_policy_arns   = (known after apply)
                [32m+[0m[0m max_session_duration  = 3600
                [32m+[0m[0m name                  = "lambda_execution_role"
                [32m+[0m[0m name_prefix           = (known after apply)
                [32m+[0m[0m path                  = "/"
                [32m+[0m[0m role_last_used        = (known after apply)
                [32m+[0m[0m tags_all              = {
                    [32m+[0m[0m "Environment" = "PRD"
                    [32m+[0m[0m "Service"     = "Protein Research"
                  }
                [32m+[0m[0m unique_id             = (known after apply)
              }
          
          [1m  # aws_iam_role_policy.ElasticSearch_IAM_Policy[0m will be created
          [0m  [32m+[0m[0m resource "aws_iam_role_policy" "ElasticSearch_IAM_Policy" {
                [32m+[0m[0m id     = (known after apply)
                [32m+[0m[0m name   = "ElS-ProteinResearch-IAM-Policy"
                [32m+[0m[0m policy = jsonencode(
                      {
                        [32m+[0m[0m Statement = [
                            [32m+[0m[0m {
                                [32m+[0m[0m Action   = "s3:*"
                                [32m+[0m[0m Effect   = "Allow"
                                [32m+[0m[0m Resource = "*"
                              },
                          ]
                        [32m+[0m[0m Version   = "2012-10-17"
                      }
                  )
                [32m+[0m[0m role   = (known after apply)
              }
          
          [1m  # aws_iam_role_policy_attachment.lambda_exec_policy_attachment[0m will be created
          [0m  [32m+[0m[0m resource "aws_iam_role_policy_attachment" "lambda_exec_policy_attachment" {
                [32m+[0m[0m id         = (known after apply)
                [32m+[0m[0m policy_arn = "arn:aws:iam::aws:policy/service-role/AWSLambdaBasicExecutionRole"
                [32m+[0m[0m role       = "lambda_execution_role"
              }
          
          [1m  # aws_instance.ProteinResearch_EC2_Instance_1[0m will be created
          [0m  [32m+[0m[0m resource "aws_instance" "ProteinResearch_EC2_Instance_1" {
                [32m+[0m[0m ami                                  = "ami-0f5bca4d7b49c9f49"
                [32m+[0m[0m arn                                  = (known after apply)
                [32m+[0m[0m associate_public_ip_address          = (known after apply)
                [32m+[0m[0m availability_zone                    = (known after apply)
                [32m+[0m[0m cpu_core_count                       = (known after apply)
                [32m+[0m[0m cpu_threads_per_core                 = (known after apply)
                [32m+[0m[0m disable_api_stop                     = (known after apply)
                [32m+[0m[0m disable_api_termination              = (known after apply)
                [32m+[0m[0m ebs_optimized                        = (known after apply)
                [32m+[0m[0m get_password_data                    = false
                [32m+[0m[0m host_id                              = (known after apply)
                [32m+[0m[0m host_resource_group_arn              = (known after apply)
                [32m+[0m[0m iam_instance_profile                 = "ELS-ProteinResearch-Instance-Profile"
                [32m+[0m[0m id                                   = (known after apply)
                [32m+[0m[0m instance_initiated_shutdown_behavior = (known after apply)
                [32m+[0m[0m instance_state                       = (known after apply)
                [32m+[0m[0m instance_type                        = "t3.2xlarge"
                [32m+[0m[0m ipv6_address_count                   = (known after apply)
                [32m+[0m[0m ipv6_addresses                       = (known after apply)
                [32m+[0m[0m key_name                             = "ELS-ProteinResearch-EC2-Key"
                [32m+[0m[0m monitoring                           = (known after apply)
                [32m+[0m[0m outpost_arn                          = (known after apply)
                [32m+[0m[0m password_data                        = (known after apply)
                [32m+[0m[0m placement_group                      = (known after apply)
                [32m+[0m[0m placement_partition_number           = (known after apply)
                [32m+[0m[0m primary_network_interface_id         = (known after apply)
                [32m+[0m[0m private_dns                          = (known after apply)
                [32m+[0m[0m private_ip                           = (known after apply)
                [32m+[0m[0m public_dns                           = (known after apply)
                [32m+[0m[0m public_ip                            = (known after apply)
                [32m+[0m[0m secondary_private_ips                = (known after apply)
                [32m+[0m[0m security_groups                      = (known after apply)
                [32m+[0m[0m source_dest_check                    = true
                [32m+[0m[0m subnet_id                            = (known after apply)
                [32m+[0m[0m tags                                 = {
                    [32m+[0m[0m "Name" = "ELS Protein Research EC2 Instance 1"
                  }
                [32m+[0m[0m tags_all                             = {
                    [32m+[0m[0m "Environment" = "PRD"
                    [32m+[0m[0m "Name"        = "ELS Protein Research EC2 Instance 1"
                    [32m+[0m[0m "Service"     = "Protein Research"
                  }
                [32m+[0m[0m tenancy                              = (known after apply)
                [32m+[0m[0m user_data                            = (known after apply)
                [32m+[0m[0m user_data_base64                     = (known after apply)
                [32m+[0m[0m user_data_replace_on_change          = false
                [32m+[0m[0m vpc_security_group_ids               = (known after apply)
              }
          
          [1m  # aws_instance.ProteinResearch_EC2_Instance_2[0m will be created
          [0m  [32m+[0m[0m resource "aws_instance" "ProteinResearch_EC2_Instance_2" {
                [32m+[0m[0m ami                                  = "ami-0f5bca4d7b49c9f49"
                [32m+[0m[0m arn                                  = (known after apply)
                [32m+[0m[0m associate_public_ip_address          = (known after apply)
                [32m+[0m[0m availability_zone                    = (known after apply)
                [32m+[0m[0m cpu_core_count                       = (known after apply)
                [32m+[0m[0m cpu_threads_per_core                 = (known after apply)
                [32m+[0m[0m disable_api_stop                     = (known after apply)
                [32m+[0m[0m disable_api_termination              = (known after apply)
                [32m+[0m[0m ebs_optimized                        = (known after apply)
                [32m+[0m[0m get_password_data                    = false
                [32m+[0m[0m host_id                              = (known after apply)
                [32m+[0m[0m host_resource_group_arn              = (known after apply)
                [32m+[0m[0m iam_instance_profile                 = "ELS-ProteinResearch-Instance-Profile"
                [32m+[0m[0m id                                   = (known after apply)
                [32m+[0m[0m instance_initiated_shutdown_behavior = (known after apply)
                [32m+[0m[0m instance_state                       = (known after apply)
                [32m+[0m[0m instance_type                        = "t3.2xlarge"
                [32m+[0m[0m ipv6_address_count                   = (known after apply)
                [32m+[0m[0m ipv6_addresses                       = (known after apply)
                [32m+[0m[0m key_name                             = "ELS-ProteinResearch-EC2-Key"
                [32m+[0m[0m monitoring                           = (known after apply)
                [32m+[0m[0m outpost_arn                          = (known after apply)
                [32m+[0m[0m password_data                        = (known after apply)
                [32m+[0m[0m placement_group                      = (known after apply)
                [32m+[0m[0m placement_partition_number           = (known after apply)
                [32m+[0m[0m primary_network_interface_id         = (known after apply)
                [32m+[0m[0m private_dns                          = (known after apply)
                [32m+[0m[0m private_ip                           = (known after apply)
                [32m+[0m[0m public_dns                           = (known after apply)
                [32m+[0m[0m public_ip                            = (known after apply)
                [32m+[0m[0m secondary_private_ips                = (known after apply)
                [32m+[0m[0m security_groups                      = (known after apply)
                [32m+[0m[0m source_dest_check                    = true
                [32m+[0m[0m subnet_id                            = (known after apply)
                [32m+[0m[0m tags                                 = {
                    [32m+[0m[0m "Name" = "ELS Protein Research EC2 Instance 2"
                  }
                [32m+[0m[0m tags_all                             = {
                    [32m+[0m[0m "Environment" = "PRD"
                    [32m+[0m[0m "Name"        = "ELS Protein Research EC2 Instance 2"
                    [32m+[0m[0m "Service"     = "Protein Research"
                  }
                [32m+[0m[0m tenancy                              = (known after apply)
                [32m+[0m[0m user_data                            = (known after apply)
                [32m+[0m[0m user_data_base64                     = (known after apply)
                [32m+[0m[0m user_data_replace_on_change          = false
                [32m+[0m[0m vpc_security_group_ids               = (known after apply)
              }
          
          [1m  # aws_key_pair.ElasticSearch_EC2_Key[0m will be created
          [0m  [32m+[0m[0m resource "aws_key_pair" "ElasticSearch_EC2_Key" {
                [32m+[0m[0m arn             = (known after apply)
                [32m+[0m[0m fingerprint     = (known after apply)
                [32m+[0m[0m id              = (known after apply)
                [32m+[0m[0m key_name        = "ELS-ProteinResearch-EC2-Key"
                [32m+[0m[0m key_name_prefix = (known after apply)
                [32m+[0m[0m key_pair_id     = (known after apply)
                [32m+[0m[0m key_type        = (known after apply)
                [32m+[0m[0m public_key      = "ssh-rsa AAAAB3NzaC1yc2EAAAADAQABAAAA..."
                [32m+[0m[0m tags_all        = {
                    [32m+[0m[0m "Environment" = "PRD"
                    [32m+[0m[0m "Service"     = "Protein Research"
                  }
              }
          
          [1m  # aws_lambda_function.protein_research_lambda[0m will be created
          [0m  [32m+[0m[0m resource "aws_lambda_function" "protein_research_lambda" {
                [32m+[0m[0m architectures                  = [
                    [32m+[0m[0m "x86_64",
                  ]
                [32m+[0m[0m arn                            = (known after apply)
                [32m+[0m[0m filename                       = "path_to_your_zip/lambda_function.zip"
                [32m+[0m[0m function_name                  = "proteinResearchLambda"
                [32m+[0m[0m handler                        = "lambda_function.lambda_handler"
                [32m+[0m[0m id                             = (known after apply)
                [32m+[0m[0m invoke_arn                     = (known after apply)
                [32m+[0m[0m last_modified                  = (known after apply)
                [32m+[0m[0m memory_size                    = 128
                [32m+[0m[0m package_type                   = "Zip"
                [32m+[0m[0m publish                        = false
                [32m+[0m[0m qualified_arn                  = (known after apply)
                [32m+[0m[0m qualified_invoke_arn           = (known after apply)
                [32m+[0m[0m reserved_concurrent_executions = -1
                [32m+[0m[0m role                           = (known after apply)
                [32m+[0m[0m runtime                        = "python3.8"
                [32m+[0m[0m signing_job_arn                = (known after apply)
                [32m+[0m[0m signing_profile_version_arn    = (known after apply)
                [32m+[0m[0m skip_destroy                   = false
                [32m+[0m[0m source_code_hash               = (known after apply)
                [32m+[0m[0m source_code_size               = (known after apply)
                [32m+[0m[0m tags_all                       = {
                    [32m+[0m[0m "Environment" = "PRD"
                    [32m+[0m[0m "Service"     = "Protein Research"
                  }
                [32m+[0m[0m timeout                        = 3
                [32m+[0m[0m version                        = (known after apply)
          
                [32m+[0m[0m environment {
                    [32m+[0m[0m variables = {
                        [32m+[0m[0m "RDS_DB_NAME"  = "ProteinResearch-Enricher-DB"
                        [32m+[0m[0m "RDS_PASSWORD" = "F0X99Pr0teIn"
                        [32m+[0m[0m "RDS_USER"     = "masteradmin"
                      }
                  }
              }
          
          [1m  # aws_s3_bucket.ElasticSearch_Snapshot_Bucket[0m will be created
          [0m  [32m+[0m[0m resource "aws_s3_bucket" "ElasticSearch_Snapshot_Bucket" {
                [32m+[0m[0m acceleration_status         = (known after apply)
                [32m+[0m[0m acl                         = (known after apply)
                [32m+[0m[0m arn                         = (known after apply)
                [32m+[0m[0m bucket                      = "elsproteinresearchsnapshotbucket"
                [32m+[0m[0m bucket_domain_name          = (known after apply)
                [32m+[0m[0m bucket_prefix               = (known after apply)
                [32m+[0m[0m bucket_regional_domain_name = (known after apply)
                [32m+[0m[0m force_destroy               = false
                [32m+[0m[0m hosted_zone_id              = (known after apply)
                [32m+[0m[0m id                          = (known after apply)
                [32m+[0m[0m object_lock_enabled         = (known after apply)
                [32m+[0m[0m policy                      = (known after apply)
                [32m+[0m[0m region                      = (known after apply)
                [32m+[0m[0m request_payer               = (known after apply)
                [32m+[0m[0m tags_all                    = {
                    [32m+[0m[0m "Environment" = "PRD"
                    [32m+[0m[0m "Service"     = "Protein Research"
                  }
                [32m+[0m[0m website_domain              = (known after apply)
                [32m+[0m[0m website_endpoint            = (known after apply)
              }
          
          [1m  # aws_s3_bucket.PR_DataBucket_1[0m will be created
          [0m  [32m+[0m[0m resource "aws_s3_bucket" "PR_DataBucket_1" {
                [32m+[0m[0m acceleration_status         = (known after apply)
                [32m+[0m[0m acl                         = (known after apply)
                [32m+[0m[0m arn                         = (known after apply)
                [32m+[0m[0m bucket                      = "prdatabucket1"
                [32m+[0m[0m bucket_domain_name          = (known after apply)
                [32m+[0m[0m bucket_prefix               = (known after apply)
                [32m+[0m[0m bucket_regional_domain_name = (known after apply)
                [32m+[0m[0m force_destroy               = false
                [32m+[0m[0m hosted_zone_id              = (known after apply)
                [32m+[0m[0m id                          = (known after apply)
                [32m+[0m[0m object_lock_enabled         = (known after apply)
                [32m+[0m[0m policy                      = (known after apply)
                [32m+[0m[0m region                      = (known after apply)
                [32m+[0m[0m request_payer               = (known after apply)
                [32m+[0m[0m tags_all                    = {
                    [32m+[0m[0m "Environment" = "PRD"
                    [32m+[0m[0m "Service"     = "Protein Research"
                  }
                [32m+[0m[0m website_domain              = (known after apply)
                [32m+[0m[0m website_endpoint            = (known after apply)
              }
          
          [1m  # aws_s3_bucket.PR_DataBucket_2[0m will be created
          [0m  [32m+[0m[0m resource "aws_s3_bucket" "PR_DataBucket_2" {
                [32m+[0m[0m acceleration_status         = (known after apply)
                [32m+[0m[0m acl                         = (known after apply)
                [32m+[0m[0m arn                         = (known after apply)
                [32m+[0m[0m bucket                      = "prdatabucket2"
                [32m+[0m[0m bucket_domain_name          = (known after apply)
                [32m+[0m[0m bucket_prefix               = (known after apply)
                [32m+[0m[0m bucket_regional_domain_name = (known after apply)
                [32m+[0m[0m force_destroy               = false
                [32m+[0m[0m hosted_zone_id              = (known after apply)
                [32m+[0m[0m id                          = (known after apply)
                [32m+[0m[0m object_lock_enabled         = (known after apply)
                [32m+[0m[0m policy                      = (known after apply)
                [32m+[0m[0m region                      = (known after apply)
                [32m+[0m[0m request_payer               = (known after apply)
                [32m+[0m[0m tags_all                    = {
                    [32m+[0m[0m "Environment" = "PRD"
                    [32m+[0m[0m "Service"     = "Protein Research"
                  }
                [32m+[0m[0m website_domain              = (known after apply)
                [32m+[0m[0m website_endpoint            = (known after apply)
              }
          
          [1m  # aws_s3_bucket.PR_DataBucket_3[0m will be created
          [0m  [32m+[0m[0m resource "aws_s3_bucket" "PR_DataBucket_3" {
                [32m+[0m[0m acceleration_status         = (known after apply)
                [32m+[0m[0m acl                         = (known after apply)
                [32m+[0m[0m arn                         = (known after apply)
                [32m+[0m[0m bucket                      = "prdatabucket3"
                [32m+[0m[0m bucket_domain_name          = (known after apply)
                [32m+[0m[0m bucket_prefix               = (known after apply)
                [32m+[0m[0m bucket_regional_domain_name = (known after apply)
                [32m+[0m[0m force_destroy               = false
                [32m+[0m[0m hosted_zone_id              = (known after apply)
                [32m+[0m[0m id                          = (known after apply)
                [32m+[0m[0m object_lock_enabled         = (known after apply)
                [32m+[0m[0m policy                      = (known after apply)
                [32m+[0m[0m region                      = (known after apply)
                [32m+[0m[0m request_payer               = (known after apply)
                [32m+[0m[0m tags_all                    = {
                    [32m+[0m[0m "Environment" = "PRD"
                    [32m+[0m[0m "Service"     = "Protein Research"
                  }
                [32m+[0m[0m website_domain              = (known after apply)
                [32m+[0m[0m website_endpoint            = (known after apply)
              }
          
          [1m  # aws_s3_bucket_policy.PR_DataBucket1_policy[0m will be created
          [0m  [32m+[0m[0m resource "aws_s3_bucket_policy" "PR_DataBucket1_policy" {
                [32m+[0m[0m bucket = (known after apply)
                [32m+[0m[0m id     = (known after apply)
                [32m+[0m[0m policy = (known after apply)
              }
          
          [1m  # aws_s3_bucket_policy.PR_DataBucket2_policy[0m will be created
          [0m  [32m+[0m[0m resource "aws_s3_bucket_policy" "PR_DataBucket2_policy" {
                [32m+[0m[0m bucket = (known after apply)
                [32m+[0m[0m id     = (known after apply)
                [32m+[0m[0m policy = (known after apply)
              }
          
          [1m  # aws_s3_bucket_policy.PR_DataBucket3_policy[0m will be created
          [0m  [32m+[0m[0m resource "aws_s3_bucket_policy" "PR_DataBucket3_policy" {
                [32m+[0m[0m bucket = (known after apply)
                [32m+[0m[0m id     = (known after apply)
                [32m+[0m[0m policy = (known after apply)
              }
          
          [1m  # aws_security_group.ElasticSearch_Security_Group[0m will be created
          [0m  [32m+[0m[0m resource "aws_security_group" "ElasticSearch_Security_Group" {
                [32m+[0m[0m arn                    = (known after apply)
                [32m+[0m[0m description            = "Security group for ElasticSearch"
                [32m+[0m[0m egress                 = [
                    [32m+[0m[0m {
                        [32m+[0m[0m cidr_blocks      = [
                            [32m+[0m[0m "0.0.0.0/0",
                          ]
                        [32m+[0m[0m description      = ""
                        [32m+[0m[0m from_port        = 0
                        [32m+[0m[0m ipv6_cidr_blocks = []
                        [32m+[0m[0m prefix_list_ids  = []
                        [32m+[0m[0m protocol         = "-1"
                        [32m+[0m[0m security_groups  = []
                        [32m+[0m[0m self             = false
                        [32m+[0m[0m to_port          = 0
                      },
                  ]
                [32m+[0m[0m id                     = (known after apply)
                [32m+[0m[0m ingress                = [
                    [32m+[0m[0m {
                        [32m+[0m[0m cidr_blocks      = [
                            [32m+[0m[0m "0.0.0.0/0",
                          ]
                        [32m+[0m[0m description      = ""
                        [32m+[0m[0m from_port        = 6379
                        [32m+[0m[0m ipv6_cidr_blocks = []
                        [32m+[0m[0m prefix_list_ids  = []
                        [32m+[0m[0m protocol         = "tcp"
                        [32m+[0m[0m security_groups  = []
                        [32m+[0m[0m self             = false
                        [32m+[0m[0m to_port          = 6379
                      },
                  ]
                [32m+[0m[0m name                   = "ElS-ProteinResearch-SecurityGroup"
                [32m+[0m[0m name_prefix            = (known after apply)
                [32m+[0m[0m owner_id               = (known after apply)
                [32m+[0m[0m revoke_rules_on_delete = false
                [32m+[0m[0m tags_all               = {
                    [32m+[0m[0m "Environment" = "PRD"
                    [32m+[0m[0m "Service"     = "Protein Research"
                  }
                [32m+[0m[0m vpc_id                 = "vpc-096420827398e34dc"
              }
          
          [1mPlan:[0m 19 to add, 0 to change, 0 to destroy.
          [0m[90m
          ─────────────────────────────────────────────────────────────────────────────[0m
          
          Note: You didn't use the -out option to save this plan, so Terraform can't
          guarantee to take exactly these actions if you run "terraform apply" now.`,
        apply: "",
        destroy: "",
      },

      Output: TERRAFORM_TASK_OUTPUT_PARAMETERS,
      Resources: [
        {
          LogicalResourceId: "EC2Instance",
          PhysicalResourceId: "i-0c342d4a5e97d353c",
          ResourceStatus: "CREATE_COMPLETE",
          ResourceStatusReason: null,
          ResourceType: "AWS::EC2::Instance",
          TimeStamp: "2023-06-19 16:15:54.219000+00:00",
        },
      ],
      StackInfo: {
        StackId:
          "arn:aws:cloudformation:us-east-1:718329617540:stack/MontyCloud-d41d4d75-be06-401b-a659-c525f53b61d0/963eb7f0-0ebb-11ee-a0e8-12b6a2542413",
        StackName: "MontyCloud-d41d4d75-be06-401b-a659-c525f53b61d0",
        StackStatus: "CREATE_COMPLETE",
      },
    },
    Status: "SUCCESS",
    TaskId: taskId,
    TaskType: taskId === TERRAFORM_TASK_ID ? TERRAFORM_APPLY : "Day2",
    UpdatedAt: "1687191363.0",
  };

  return data;
};
